// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static-" + (["1.11916"][{"3694":0}[chunkId]] || "1.11920") + "/" + chunkId + ".js";
};